import { Component, OnInit, Input } from '@angular/core';
import { Navegacion } from '../../interfaces/navegacion.interface';
import {Router} from '@angular/router';

@Component({
  selector: 'app-navegacion',
  templateUrl: './navegacion.component.html',
  styleUrls: ['./navegacion.component.scss']
})
export class NavegacionComponent implements OnInit {

  @Input() navegacion: Navegacion;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }


  atras(){
     this.router.navigate([this.navegacion.rutaAtras]);
  }

}
